import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import Avatar, { ICON_COLOR } from '@scoir/avatar'

import { RelatedCareerOption } from './career-service'
import { getIndustryIcon } from './get-industry-icon'

type SimilarCareerProps = {
  relatedOccupation: RelatedCareerOption
  onAdd: (relatedOccupation: RelatedCareerOption) => void
}

const SimilarCareer = ({ relatedOccupation, onAdd }: SimilarCareerProps) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })

  const industryIcon = getIndustryIcon(relatedOccupation.Industry || '')

  return (
    <ListItem
      disableGutters
      key={relatedOccupation.Title}
    >
      <ListItemIcon>
        <Avatar
          aria-label="industry icon"
          iconColor={ICON_COLOR.info}
          variant="circular"
          size="sm"
          fallbackIcon={
            <FontAwesomeIcon
              size="1x"
              icon={industryIcon}
            />
          }
        />
      </ListItemIcon>
      <ListItemText
        primary={relatedOccupation.Title}
        secondary={
          <Typography
            variant="body2"
            color="textSecondary"
          >
            {relatedOccupation.MedianIncome && (
              <>
                {formatter.format(relatedOccupation.MedianIncome)}
                {relatedOccupation.EducationLevel && ' • '}
              </>
            )}
            {relatedOccupation.EducationLevel && (
              <>
                {relatedOccupation.EducationLevel}
                {relatedOccupation.Outlook && ' • '}
              </>
            )}
            {relatedOccupation.Outlook && relatedOccupation.Outlook + ' Outlook'}
          </Typography>
        }
      />
      <ListItemSecondaryAction>
        <IconButton
          color="primary"
          onClick={() => onAdd(relatedOccupation)}
        >
          <FontAwesomeIcon
            icon={faPlus}
            size="sm"
          />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default SimilarCareer
